// User-facing copy: signIn. Moved from the web app (components/CodeBoxes.tsx, components/SignIn.tsx, pages/DevLogin.tsx, pages/EmailLinks.tsx, pages/SignIn.tsx, lib/auth.ts) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** components/CodeBoxes.tsx */
export const codeBoxes = {
    codeFromTheEmail: "Code from the email",
    digitOf: (x, EMAIL_CODE_LENGTH) => `Digit ${x} of ${EMAIL_CODE_LENGTH}`,
};
/** components/SignIn.tsx */
export const buttons = {
    orSep: " or ",
    continueWith: "Continue with",
    weOnlyUseThis: "We only use this to sign you in. We never post anything for you.",
    waysToSignIn: "Ways to sign in",
    anyOfTheseOpens: "Any of these opens the same account. Add one so you're never locked out",
    orCanUseThe: (x) => `, or can use the app on a phone that doesn't have ${x}`,
    isLinked: (x) => `${x} is linked.`,
    nextTimeEitherButton: " Next time, either button gets you here.",
    linked: "linked",
    notLinked: "not linked",
    onlyWayIn: "only way in",
    remove: "remove",
    opening: "Opening…",
    link: "Link",
    emailCode: "Email code",
    withAnyConfirmedAddress: "with any confirmed address below",
    removeYouDSign: (x, join) => `Remove ${x}? You'd sign in with ${join} from then on. Your clubs, notes and progress stay.`,
    anEmailCode: "an email code",
    remove2: "Remove",
    keep: "Keep",
    thisAccountIsBrand: "This account is brand new.",
    ifYouAlreadyUse: (used) => ` If you already use Pagemates with another sign-in, sign out, sign in the way you did before, and link ${used} from your profile. Then both work.`,
};
/** pages/DevLogin.tsx */
export const devLogin = {
    signingIn: "Signing in…",
};
/** pages/EmailLinks.tsx */
export const emailLinks = {
    pagematesHome: "Pagemates home",
    signingYouIn: "Signing you in",
    asInThisBrowser: (email) => `as ${email}, in this browser`,
    thisLinkHasBeen: "This link has been used or has run out",
    codesWorkOnceFor: "Codes work once, for 10 minutes. Ask for a new one.",
    sendANewCode: "Send a new code",
    confirming: "Confirming",
    confirmingYourAddress: "Confirming your address",
    addressConfirmed: "Address confirmed",
    itCanSignYou: "It can sign you in now, and get the emails you choose in Settings.",
    openPagemates: "Open Pagemates",
    thatLinkDidnT: "That link didn't work",
    youCanSendA: (x) => `${x} You can send a new one from Settings.`,
    itMayHaveBeen: "It may have been used or run out.",
    goToSettings: "Go to Settings",
};
/** pages/SignIn.tsx */
export const page = {
    pagematesHome: "Pagemates home",
    policyAndContact: "Policy and contact",
    checkYourEmail: "Check your email",
    weSentACode: "We sent a code to ",
    itSignsYouIn: "It signs you in as soon as the sixth digit is in. It works once, for 10 minutes.",
    sendANewCode: (padStart) => `Send a new code in 0:${padStart}`,
    sendANewCode2: "Send a new code",
    useADifferentEmail: "Use a different email",
    theEmailSSign: "The email's \"Sign in\" button works too, in whichever browser it opens. Nothing there? Check spam, or the address above.",
    signInToPagemates: "Sign in to Pagemates",
    enterYourEmail: "Enter your email.",
    yourEmail: "Your email",
    sending: "Sending…",
    emailMeACode: "Email me a code",
    newHereAnyOf: "New here? Any of these makes your account. ",
    whatIsPagemates: "What is Pagemates?",
};
/** lib/auth.ts */
export const providers = {
    discord: "Discord",
    google: "Google",
    apple: "Apple",
};
//# sourceMappingURL=signIn.js.map